import { Component, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType } from 't4core';
import * as uuid from 'uuid';

@Component({
  selector: 'ImageDialog',
  templateUrl: 'ImageDialog.html',
  styleUrls: ['./ImageDialog.css']
})
export class ImageDialog extends DialogBase {

  @ViewChild('container', { static: false }) container: ElementRef;

  rotateDegrees = 0;
  containerTransform = '';

  constructor(
    public dialogRef: MatDialogRef<ImageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ImageDialog");

  }

  public async ngOnInit() {
    this.loading = true;
    this.loading = false;
  }

  public close() {
    this.dialogRef.close(this.data);
  }


  rotateContainer() {
    this.rotateDegrees += 90;
    this.containerTransform = `rotate(${this.rotateDegrees}deg)`;
  }

  
}
